import * as Yup from 'yup';

export const sendShopifyOrderSchema = Yup.object().shape({
  shopifyStore: Yup.object().required('Store is required'),
  shopifyOrderId: Yup.string()
    .matches(/^\d*$/, 'The Order Id must have a numeric value.')
    .required('Shopify order ID is required'),
});
